<script lang='ts'>
import HeaderBox from './HeaderBox.svelte';
import BadgeRank from './BadgeRank.svelte';
import BadgeCard from './BadgeCard.svelte';
import { isBadgeDone, type Badge, type Rank } from '../services';

export let onPage;
export let sectionTitle;
export let title;
export let subtitle;
export let header;
export let badges: Badge[];
export let rank: Rank;
export let leaderboard: Rank[];
export let leaderboardLessPages;
export let leaderboardMorePages;
export let leaderboardWidth;

let showBadge;
</script>

<div class="section-header">{sectionTitle}</div>

<HeaderBox {title} {subtitle} style={header} />

<div class='rowtocol'>
  <div class='col'>
    <div class='title'>Your Rank</div>
    <div class='card shadow col hcenter' style="height:100%; width: 190px">
      {#if rank.points === 0}
        <div class="col flex-1 vcenter hcenter not-ready">
          Unlock you first achievement to reveal rank
        </div>
        <div class='name'>{rank.name}</div>
        <div class='row vcenter points'>
          0 <img src="/img/point.png" />
        </div>
      {:else}
        <BadgeRank {rank} />
      {/if}
    </div>
  </div>
  <div class='vpipe' />
  <div class='col flex-1' style='min-width: 0'>
    <div class='title'>Leaderboard</div>
    <div class='row card shadow flex-1' style="overflow: hidden" bind:clientWidth={leaderboardWidth}>
      {#if leaderboard.length === 0}
        <div class="row flex-1 vcenter hcenter not-ready">
          Waiting on participants
        </div>
      {:else}

        {#if leaderboardLessPages}
          <button on:click={() => onPage(false)}>Back</button>
        {/if}

        {#each leaderboard as person}
          <BadgeRank rank={person} />
        {/each}

        {#if leaderboardMorePages}
          <button on:click={() => onPage(true)}>Next</button>
        {/if}

      {/if}
    </div>
  </div>
</div>

<div class="row wrap" style="gap: 16px; margin-top: 16px;">
  {#each badges as badge}
    <BadgeCard {badge} on:click={() => {if (isBadgeDone(badge) && badge.link) window.open(badge.link, '_blank')}} />
  {/each}
</div>

{#if showBadge}
  <div class='modal'>
    
  </div>
{/if}

<style lang="scss">
@import '../util';

.not-ready {
  font-style: italic;
  text-align: center;
  padding: 16px 0;
}
.vpipe {
  // background-color: grey;
  width: 20px;
  height: 80%;
}

.points {
  font-weight: bold;
}

.points img {
  margin-left: 6px;
}

.card {
  padding: 12px 8px;
  border-radius: 8px;
  margin-bottom: 16px;
}

.title {
  font-size: 24px;
  font-weight: 700;
}

.modal-container {
  background-color: white;
  border-radius: 5px;
  color: black;
  padding: 6px;
  min-width: 320px;
  min-height: 185px;

  @include tablet {
    padding: 0;
    background-color: unset;
    border-radius: unset;
  }
}

.badge {
  @include shadow;
  position: relative;
  width: 320px;
  height: 185px;
  background-color: white;
  // border-radius: 5px;
  color: white;
  margin: 8px;
  padding: 16px;
  cursor: pointer;
  background-size: cover;
  overflow: hidden;
  transition: ease-out 150ms;
  
  &:hover {
    transform: scale(1.05);
  }
}

.bar {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(0deg, rgba(0,0,0,1) 0%, rgba(0,0,0,0) 100%);
  padding: 4px;
  font-size: 20px;
}

.highlight {
  color: var(--guardsmen-red);
}

.icon {
  background-color: white;
  border-radius: 8px;
  margin-right: 5px;
  pointer-events: none;

  width: 28px;
  height: 28px;
}
</style>